export interface PreloaderConfig {
    element: string,
    timeout?: number
}

export class Preloader {
    private readonly element: HTMLElement;
    public timeout: number;

    constructor({element, timeout = 0}: PreloaderConfig) {
        this.element = document.querySelector(element);
        this.timeout = timeout;
    }

    public hide(): void {
        if (!this.element) throw new ReferenceError(`No Preloader element found`);
        this.element.style.display = `none`;
    }

    public show(): void {
        if (!this.element) throw new ReferenceError(`No Preloader element found`);
        this.element.style.display = `flex`;
    }

    private hideAfterTimeout(): void {
        window.onload = () => this.hide();
    }

    private hideAfterLoad(): void {
        new Promise((resolve, reject) => setTimeout(resolve, this.timeout))
            .then(() => this.hide());
    }

    init(): void {
        if (!this.element) return;
        this.timeout ? this.hideAfterLoad() : this.hideAfterTimeout();
    }
}